import RateTypeTab from './rate-type-tab';
import PeriorityTab from './priority-tab';

function DecksTab() {
  return (
    <div className='mb-8'>
      <PeriorityTab />
      <RateTypeTab />
    </div>
  );
}

export default DecksTab;
